import { ACTION, DATA_VARIANT, ROUTES } from 'consts'
import { decodeJWT } from 'utils'


var initialState = [];
var dataVariant = (state = initialState, action) => {
  switch (action.type) {
    case DATA_VARIANT: {

      state.push(action.data);
      return [...state];
    }


    default:
      return state
  }
}
export default dataVariant
